import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiUrlProvider } from './api-url.provider';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { Operation } from '../shared/models/operation';

@Injectable({
  providedIn: 'root'
})
export class RoleOperationService {
  constructor(
    private http: HttpClient,
    private apiUrlProvider: ApiUrlProvider) { }

  getOperations(): Observable<IApiResult<Operation[]>>{
    return this.http.get<IApiResult<Operation[]>>(`${this.apiUrlProvider.url}/Operations`);
  }

  getOperationsByRole(roleId: number): Observable<IApiResult<Operation[]>>{
    return this.http.get<IApiResult<Operation[]>>(`${this.apiUrlProvider.url}/Roles/${roleId}/Operations`);
  }

  addOperationToRole(roleId: number, operationId: number): Observable<IApiResult<Operation[]>>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.post<IApiResult<Operation[]>>(`${this.apiUrlProvider.url}/Roles/${roleId}/Operations/${operationId}`, null, httpOptions);
  }

  deleteOperationFromRole(roleId: number, operationId: number): Observable<IApiResult<Operation[]>>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.post<IApiResult<Operation[]>>(`${this.apiUrlProvider.url}/Roles/${roleId}/Operations/${operationId}/Delete`, null, httpOptions);
  }
}
